module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/288_symbol_toad@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/288_symbol_toad@1x.png
// module id = 689
// module chunks = 0